import React from 'react';

/**
 * Name (top) + slug (bottom) with optional conflict message.
 */
export default function NameSlugFields({
  name,
  slug,
  onNameChange,
  onSlugChange,
  slugConflict = null,
  nameError = null,
  slugError = null,
  isEdit = false,
  nameLabel = 'Name',
  slugLabel = 'Slug',
  nameId = 'item-name',
  slugId = 'item-slug',
  namePlaceholder = 'Human readable name',
  slugPlaceholder = 'auto-generated-from-name',
  nameDisabled = false,
  slugDisabled = false,
  slugHelp = null,
  required = true,
  className = 'form-group',
  rowClassName = '',
  nameClassName,
  slugClassName,
}) {
  const req = required ? <span className="required">*</span> : null;
  const nameWrapClass = nameClassName || `${className} ${rowClassName}`.trim();
  const slugWrapClass = slugClassName || `${className} ${rowClassName}`.trim();

  return (
    <>
      <div className={nameWrapClass}>
        <label htmlFor={nameId}>
          {nameLabel} {req}
        </label>
        <input
          type="text"
          id={nameId}
          value={name}
          onChange={(e) => onNameChange(e.target.value)}
          placeholder={namePlaceholder}
          disabled={nameDisabled}
          className={nameError ? 'error' : ''}
          required={required}
        />
        {nameError && (
          <div className="field-error">
            <i className="fas fa-exclamation-triangle" aria-hidden />
            {nameError}
          </div>
        )}
      </div>
      <div className={slugWrapClass}>
        <label htmlFor={slugId}>
          {slugLabel} {req}
        </label>
        <input
          type="text"
          id={slugId}
          value={slug}
          onChange={(e) => onSlugChange(e.target.value)}
          placeholder={slugPlaceholder}
          disabled={slugDisabled || isEdit}
          className={slugError || slugConflict ? 'error' : ''}
          required={required}
        />
        {slugConflict && (
          <div className="field-error">
            <i className="fas fa-exclamation-triangle" aria-hidden />
            {slugConflict}
          </div>
        )}
        {!slugConflict && slugError && (
          <div className="field-error">
            <i className="fas fa-exclamation-triangle" aria-hidden />
            {slugError}
          </div>
        )}
        {isEdit && slugHelp !== false && (
          <small className="form-help">{slugHelp || `${slugLabel} cannot be changed after creation`}</small>
        )}
        {!isEdit && (
          <small className="form-help">Generated from the name; edit manually if needed.</small>
        )}
      </div>
    </>
  );
}
